import * as Images from 'pos/Images';
import { Res } from 'core/api';

import * as Division from './Division';
import { CustomError } from 'core/infrastructure';
import { PosScreenClassComponent, ScreenSize, ThemeManager } from 'pos/ui';
import { Message, Modal } from 'core/ui-next/modal';

type Props = { initialStatus: Division.TicketDivisionStatus, tableCompanions: Nullable<number> } & Modal.Actions<void>;

export abstract class DivisionScreen<S extends Division.TicketDivisionStatus> extends PosScreenClassComponent<Props, S> {

	protected getSize(): ScreenSize {
		return ThemeManager.isLargeDevice() ? { width: 1000, height: 700 } : 'medium';
	}

	protected getScreenId(): string {
		return 'TICKET_DIVISION';
	}

	protected getTitle(): string {
		return Res.Web.SPLIT_TICKET();
	}

	protected getImage(): string | SvgIcon {
		return Images.SplitTicket;
	}

	protected useKeypad() {
		return false;
	}

	onComponentDidMount(): void {

		this.on('pos:split-ticket:operation-failed', async ({ msg, error, targetTicket }: { msg: string, error: CustomError, targetTicket: 'left' | 'right' }) => {

			await Message.show(msg);

			// Si es un error de impresión o es un fallo cuando estoy cerrando la cuenta parcial
			// me quedo en esta pantalla, ya que mi ticket original no ha sido modificado y en teoría no se ha tocado.
			// Si no me quedo en esta pantalla y se cierra antes que la que tenga por encima se pueden lanzar errores.
			// Lo he comprobado cuando se deshacen los pagos con el Carbon de Redsys.
			if (error.isPrintError() || targetTicket === 'right')
				return;

			this.cancel();
		});

		this.on('pos:split-ticket:completed', async () => {
			this.close();
		});
	}

	onComponentWillUnmount(): void { }
}
